import viewWorkOrder from './viewWorkOrder';
import approveWorkOrder from './approveWorkOrder';

export default {
	viewWorkOrderPage: viewWorkOrder,
	approveWorkOrderPage: approveWorkOrder
}